import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card, CardContent } from "@/components/ui/card";
import { toast } from "sonner";
import { Loader2, Shield } from "lucide-react";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const r = await api.post("/admin/login", { email, password });
      // Persist the token so the dashboard can authenticate even when
      // third-party cookies get blocked (e.g. Safari ITP, Chrome strict mode).
      if (r.data?.token && typeof window !== "undefined") {
        window.localStorage.setItem("ybtv_admin_token", r.data.token);
      }
      toast.success("Admin signed in");
      navigate("/admin/dashboard");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Invalid credentials");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0A0A0E] text-white grid place-items-center px-6">
      <Card className="w-full max-w-md bg-[#141419] border-white/10 text-white">
        <CardContent className="p-8">
          <div className="flex items-center gap-2 text-[#FFD700] text-xs uppercase tracking-[0.3em] font-semibold mb-3">
            <Shield className="w-3.5 h-3.5" /> Restricted
          </div>
          <h1 className="font-display text-3xl font-bold tracking-tight">Admin sign in</h1>
          <p className="text-gray-400 text-sm mt-1">Manage YBTV content library.</p>

          <form onSubmit={submit} className="mt-7 space-y-4">
            <div>
              <Label htmlFor="email" className="text-gray-300">Email</Label>
              <Input
                id="email"
                data-testid="admin-email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="mt-1 bg-black/40 border-white/20 text-white"
                placeholder="admin@stream.com"
                required
              />
            </div>
            <div>
              <Label htmlFor="password" className="text-gray-300">Password</Label>
              <Input
                id="password"
                data-testid="admin-password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="mt-1 bg-black/40 border-white/20 text-white"
                placeholder="••••••••"
                required
              />
            </div>
            <Button
              data-testid="admin-login-btn"
              type="submit"
              disabled={loading}
              className="w-full rounded-full bg-[#E50914] hover:bg-[#F40612] text-white py-6 font-semibold"
            >
              {loading ? <><Loader2 className="w-4 h-4 mr-2 animate-spin"/> Signing in…</> : "Sign in"}
            </Button>
          </form>
        </CardContent>
      </Card>
    </div>
  );
}
